import { IInputTheme } from '../../models/IInputTheme';
import { colors } from './colors';

export const inputTheme: IInputTheme = {
  withCleanButton: false,
  variants: {
    outline: {
      border: {
        top: '1px',
        left: '1px',
        right: '1px',
        bottom: '1px',
      },
      padding: {
        top: '10px',
        left: '15px',
        right: '7px',
        bottom: '10px',
      },
      borderRadius: '3px',
      color: colors.notTransactional.base,
      borderColor: colors.neutral.color2,
      backgroundColor: colors.neutral.white,
    },
    flushed: {
      border: {
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '1px',
      },
      padding: {
        top: '5px',
        left: '1px',
        right: '7px',
        bottom: '5px',
      },
      borderRadius: '0px',
      color: colors.notTransactional.base,
      borderColor: colors.notTransactional.base,
      backgroundColor: colors.neutral.white,
    },
    baseline: {
      padding: {
        top: '3px',
        left: '3px',
        right: '7px',
        bottom: '4px',
      },
      border: {
        top: '0',
        left: '0',
        right: '0',
        bottom: '1px',
      },
      borderRadius: '0',
      color: colors.neutral.gray,
      borderColor: colors.neutral.silver,
      backgroundColor: colors.neutral.grayLight,
    },
  },
  state: {
    error: {
      color: colors.notTransactional.red,
      borderColor: colors.notTransactional.red,
      fontSize: '12px',
      lineHeight: '14px',
    },
    success: {
      color: colors.neutral.green,
      borderColor: colors.neutral.green,
    },
  },
};
